import React, { Component } from 'react';
// import {Link} from 'react-router-dom';

class Sidebar extends Component {
    render() {
        const { projectData } = this.props;

        if (!projectData) {
            return null;
        }

        // Format surface area
        const formattedSurfaceArea = projectData.surfaceArea ? 
            `${projectData.surfaceArea} Sq Ft` : "Not specified";

        return (
            <div className="detail-info">
                <div className="content-info">
                    <div className="themesflat-headings style-2 clearfix">
                        <h2 className="heading line-height-62">{projectData.title || "PROJECT NAME"}</h2>
                        <div className="sep has-width w80 accent-bg clearfix">
                        </div>
                    </div>
                    <ul className="list-info has-icon icon-left">
                        <li>
                            <span className="text">Client <span className="icon"><i className="fa fa-user" /></span></span>
                            <span className="right">{projectData.client || "Not specified"}</span>
                        </li>
                  
                        <li>
                            <span className="text">Surface Area <span className="icon"><i className="fa fa-search" /></span></span>
                            <span className="right">{formattedSurfaceArea}</span>
                        </li>
                        
                        <li>
                            <span className="text">Year completed <span className="icon"><i className="fa fa-calendar" /></span></span>
                            <span className="right">{projectData.yearCompleted || "Not specified"}</span>
                        </li>

                        <li>
                            <span className="text">Location <span className="icon"><i className="fa fa-map-marker" /></span></span>
                            <span className="right">{projectData.location || "Not specified"}</span>
                        </li>

                        <li>
                            <span className="text">Project Type <span className="icon"><i className="fa fa-building" /></span></span>
                            <span className="right">{projectData.projectType || "Not specified"}</span>
                        </li>

                        <li>
                            <span className="text">Status <span className="icon"><i className="fa fa-flag" /></span></span>
                            <span className="right">{projectData.status || "Not specified"}</span>
                        </li>
                        
                        {/* <li>
                            <span className="text">Tag <span className="icon"><i className="fa fa-tag" /></span></span>
                            <span className="right">
                                {projectData.tag && projectData.tag.length > 0 ? (
                                    projectData.tag.map((tag, index) => (
                                        <React.Fragment key={index}>
                                            <Link to={`/tag/${tag}`}>{tag}</Link>
                                            {index < projectData.tag.length - 1 && ' / '}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <span>No tags</span>
                                )}
                            </span>
                        </li> */}
                    </ul>
                </div>
                
                <div className="themesflat-spacer clearfix" data-desktop={46} data-mobile={35} data-smobile={35} />


                
                
                {/* Brochures section - you can add this later when you have brochures in your model */}
                <div className="content-info info-brochures">
                    {/* <div className="themesflat-headings style-2 clearfix">
                        <h2 className="heading line-height-62">BROCHURES</h2>
                        <div className="sep has-width w60 accent-bg clearfix">
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={34} data-mobile={35} data-smobile={35} />
                    
                    <div className="button-wrap has-icon icon-left size-14 pf21">
                        <Link to="#" className="themesflat-button font-default bg-light-white w100">
                            <span>Download Brochure <span className="icon"><i className="fa fa-file-pdf-o" /></span></span>
                        </Link>
                    </div> */}
                </div>
            </div>
        );
    }
}

export default Sidebar;